// @flow
import React from 'react';
// Components
import { BigClubIndicator } from '../../user';
import { Link } from 'react-router-dom';
// Styles
import './BigClubButton.css';

type Props = {
  redirectLink: string,
  bigClubInformation?: Object,
  showBigClubInformation: boolean,
  featuresConfigLoading: boolean,
  validatingUserLoading: boolean,
  bigClubEnabled: boolean,
};

const BigClubButton = (props: Props) => {
  const bigClubInfoLoading = props.validatingUserLoading;

  return (
    <>
      {props.featuresConfigLoading ? (
        <div className="bottomrow-bigclub-main bottomrow-bigclub-skeleton-wrapper">
          <div className="bottomrow-bigclub-skeleton skeleton-block" />
        </div>
      ) : (
        !!props.bigClubEnabled && (
          <Link to={props.redirectLink} className="bottomrow-bigclub-main">
            <div className="bottomrow-bigclub">
              <p>
                <b>Big</b>Club
              </p>
              <div />

              {bigClubInfoLoading ? (
                <div className="bottomrow-bigclub-info-skeleton-wrapper">
                  <div className="bottomrow-bigclub-info-skeleton skeleton-block" />
                  <div className="bottomrow-bigclub-info-skeleton skeleton-block" />
                </div>
              ) : props.showBigClubInformation ? (
                <p>
                  <BigClubIndicator
                    bigClubInformation={props.bigClubInformation}
                  />
                </p>
              ) : (
                <span>
                  O nosso{' '}
                  <b>
                    programa
                    <br /> de fidelidade
                  </b>
                </span>
              )}
            </div>
          </Link>
        )
      )}
    </>
  );
};

export default BigClubButton;
